import { z } from 'zod';

import { OrgIdSchema } from '../_shared/identifiers';

import { CardIdSchema } from './card_id';

/**
 * Wire contract for the `card.created` event kanban publishes (to SNS)
 * after a card is created without a squad, and consumes (from SQS) to run
 * the async LLM triage classifier.
 *
 * Payload is intentionally minimal — the consumer reloads the card, the
 * org triage config, and the squads from kanban's own store. `messageId`
 * is a publisher-controlled UUID used for log correlation. The SNS→SQS
 * subscription uses `RawMessageDelivery = true`, so the SQS body is this
 * JSON directly (no SNS envelope to strip).
 */
export const CardCreatedEventSchema = z
  .object({
    messageId: z.uuid(),
    orgId: OrgIdSchema,
    cardId: CardIdSchema,
    occurredAt: z.iso.datetime(),
  })
  .strict();

export type CardCreatedEvent = z.infer<typeof CardCreatedEventSchema>;
